import SendNotification from './SendNotification';

export default SendNotification;
